module.exports = __webpack_public_path__ + "static/media/img_map@2x.f1c8b353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_map@2x.png
// module id = 870
// module chunks = 0